import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { RootState, StoreUserState, Dispatcher } from 'AppTypes'

import { IconWithText } from '@share/components'

import { storeUserActions } from '@features/store_user/state_management/actions'

import AppBarNotificationMenu from './partials/AppBarNotificationMenu'

type Props = {
  storeUserState: StoreUserState
  dispatch: Dispatcher
}

const TopMenu: React.FC<Props> = ({
  dispatch
}) => {
  const { t } = useTranslation()

  const dispatchLogout = () => {
    dispatch(storeUserActions.logout())
  }

  return (
    <ul className="navbar-nav ml-auto">
      <li className="nav-item dropdown">
        <AppBarNotificationMenu />
      </li>
      <li className="nav-item">
        <Link className="nav-link" to="/">
          <IconWithText
            textFirst
            label={t('mainToolbar.storePageDisplayBtn')}
            icon="fa-copy"
            classes={{
              label: 'text-link'
            }}
          />
        </Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" to="/">
          <IconWithText
            textFirst
            label={t('mainToolbar.helpBtn')}
            icon="fa-question-circle"
            classes={{
              label: 'text-link'
            }}
          />
        </Link>
      </li>
      <li className="nav-item mr-0">
        <Link className="nav-link" to="#" onClick={dispatchLogout}>
          <IconWithText
            textFirst
            label={t('mainToolbar.logoutBtn')}
            icon="fa-sign-out-alt"
          />
        </Link>
      </li>
    </ul>
  )
}

export default connect((state: RootState) => ({
  storeUserState: state.storeUser
}))(TopMenu)
